export const TYPE_MESH = 'Mesh';
export const TYPE_GROUP = 'Group';
